const WalletIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4_79)">
        <path
          d="M18.5 14.5C19.328 14.5 20 15.172 20 16C20 16.828 19.328 17.5 18.5 17.5C17.672 17.5 17 16.828 17 16C17 15.172 17.672 14.5 18.5 14.5ZM23 10C22.447 10 22 10.448 22 11V21C22 21.552 21.552 22 21 22H5C3.346 22 2 20.654 2 19V9C2 9 2 8.996 2 8.995C2.854 9.635 3.903 10 4.999 10H13C13.553 10 14 9.552 14 9C14 8.448 13.553 8 13 8H5C4.144 8 3.347 7.619 2.783 6.996C3.332 6.389 4.118 6 5 6H12C12.553 6 13 5.552 13 5C13 4.448 12.553 4 12 4H5C2.224 3.994 0.02 6.304 0 9V19C0 21.757 2.243 24 5 24H21C22.654 24 24 22.654 24 21V11C24 10.448 23.553 10 23 10ZM17.497 9.385C18.312 10.2 19.645 10.207 20.461 9.394L22.697 7.217C23.093 6.832 23.101 6.199 22.717 5.803C22.33 5.407 21.697 5.398 21.303 5.784L20 7.052V1C20 0.448 19.553 0 19 0C18.447 0 18 0.448 18 1V7.07L16.703 5.789C16.309 5.401 15.678 5.404 15.288 5.798C14.9 6.191 14.904 6.824 15.297 7.212L17.497 9.385Z"
          fill="#01486D"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_79">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WalletIcon;
